import React, { useEffect, useRef, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
// import Button from "../../Components/Utils/Button";
// import Input from "../../Components/Utils/Input";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

// import Select from "../../Components/Utils/Select";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import BaseApi from "../../Http/BaseApi";
// import { getAcademicSessionsAsync } from "../../Redux/MasterSlice";
import PageTitle from "../../Components/Common/PageTitle";
import Alert from "../../Components/Utils/Alert";
import Input from "../../Components/Utils/Input";
import can from "../../Middleware/Permission";

export default function ProposalReport() {
  const formikRef = useRef();
  const formikRefAccepted = useRef();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [message, setMessage] = useState();

  // Get active tab from URL, default to "submitted"
  const activeTab = searchParams.get("tab") || "submitted";

  const canDelete =
    can("Delete Proposal Reports") || can("Account Masters");

  // const { message } = useSelector((state) => state.message);
  //   const navigate = useNavigate();

  // let formSections = useSelector((state) => state.applicants.formSections);

  const initialValues = {
    from_date: null,
    to_date: null,
  };
  const validationSchema = Yup.object().shape({
    from_date: Yup.string().nullable().required("This field is required!"),
    to_date: Yup.string().nullable().required("This field is required!"),
  });

  const handleSearch = async (searchQuery, type) => {
    setLoading(true);
    console.log(searchQuery);
    await genReport({ ...searchQuery, type });
    setLoading(false);
  };

  //   const dispatch = useDispatch();
  useEffect(() => {
    // if (academicSessions.length === 0) {
    //   dispatch(getAcademicSessionsAsync());
    // }
    getReports();
    // dispatch(getOldStudentsAsync());
  }, [dispatch]);

  async function getReports() {
    setReports([]);
    setLoading(true);

    const response = await BaseApi().get(`reports/proposals`);
    setReports(response.data);
    setLoading(false);
  }
  async function genReport(searchQuery) {
    const response = await BaseApi().post(`reports/proposals`, searchQuery);
    setMessage(response.data);
  }

  const handleDelete = async (filename) => {
    if (!window.confirm("Are you sure you want to delete this report?")) {
      return;
    }

    try {
      setLoading(true);
      const response = await BaseApi().delete(
        `reports/proposals/${encodeURIComponent(filename)}`
      );
      setMessage(response.data.message || "Report deleted successfully");
      // Refresh the reports list
      await getReports();
      setLoading(false);
    } catch (error) {
      setMessage(error.response?.data?.message || "Failed to delete report");
      setLoading(false);
    }
  };

  // Filter reports based on active tab
  const filteredReports = reports.filter((report) => {
    if (activeTab === "accepted") {
      return report.name.includes("proposals_accepted_");
    } else {
      return report.name.includes("proposals_created_");
    }
  });

  return (
    <>
      <div className='py-2'>
        <div className='mx-auto container bg-white dark:bg-gray-800 shadow rounded'>
          <div className='w-full px-5 overflow-x-scroll '>
            <PageTitle name='Proposal Reports' />
            <div className=''>{message && <Alert message={message} />}</div>

            {/* Tabs */}
            <div className='border-b border-gray-200 dark:border-gray-700'>
              <nav className='-mb-px flex space-x-8' aria-label='Tabs'>
                <button
                  onClick={() => {
                    setSearchParams({ tab: "submitted" });
                  }}
                  className={`${
                    activeTab === "submitted"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                >
                  Submitted
                </button>
                <button
                  onClick={() => {
                    setSearchParams({ tab: "accepted" });
                  }}
                  className={`${
                    activeTab === "accepted"
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                >
                  Accepted
                </button>
              </nav>
            </div>

            {/* Submitted Tab */}
            {activeTab === "submitted" && (
              <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => handleSearch(values, "submitted")}
              >
                <Form>
                  <div className=' p-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-6 xl:grid-cols-6 pt-6 gap-2'>
                    <Input
                      type='date'
                      name='from_date'
                      label='Submitted Date From *'
                    />
                    <Input
                      type='date'
                      name='to_date'
                      label='Submitted Date To *'
                    />
                    <div className='text-left mt-6  '>
                      <button
                        type='submit'
                        className='group  relative w-50  py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                        disabled={loading}
                      >
                        <span>Generate</span>
                      </button>
                    </div>
                  </div>
                </Form>
              </Formik>
            )}

            {/* Accepted Tab */}
            {activeTab === "accepted" && (
              <Formik
                innerRef={formikRefAccepted}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => handleSearch(values, "accepted")}
              >
                <Form>
                  <div className=' p-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-6 xl:grid-cols-6 pt-6 gap-2'>
                    <Input
                      type='date'
                      name='from_date'
                      label='Accepted Date From *'
                    />
                    <Input
                      type='date'
                      name='to_date'
                      label='Accepted Date To *'
                    />
                    <div className='text-left mt-6  '>
                      <button
                        type='submit'
                        className='group  relative w-50  py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                        disabled={loading}
                      >
                        <span>Generate</span>
                      </button>
                    </div>
                  </div>
                </Form>
              </Formik>
            )}

            {loading == true && (
              <>
                <div className='flex'>
                  <span className='m-auto'>
                    <ThreeDots
                      height='100'
                      width='100'
                      color='grey'
                      ariaLabel='loading'
                    />
                  </span>
                </div>
              </>
            )}

            <table
              id='datatable'
              className='min-w-full mt-5 bg-white dark:bg-gray-800'
            >
              <thead>
                <tr>
                  <th className='table-head'>#</th>

                  <th className='table-head'>File Name</th>
                  <th className='table-head'>Generated At</th>
                  <th className='table-head'>Action</th>
                  {canDelete && <th className='table-head'>Delete</th>}
                </tr>
              </thead>
              <tbody>
                {filteredReports?.length > 0 &&
                  filteredReports.map((report, index) => {
                    return (
                      <>
                        <tr>
                          <td className='table-data'>{++index}</td>
                          <td className='table-data'>{report.name}</td>
                          <td className='table-data'>{report.time}</td>
                          <td className='table-data'>
                            <a className=' text-blue-600' href={report.link}>
                              Download
                            </a>
                          </td>
                          {canDelete && (
                            <td className='table-data'>
                              <button
                                onClick={() => handleDelete(report.name)}
                                className='text-red-600 hover:text-red-800 font-medium'
                                disabled={loading}
                              >
                                Delete
                              </button>
                            </td>
                          )}
                        </tr>
                      </>
                    );
                  })}
              </tbody>
            </table>
            {filteredReports?.length == 0 && (
              <div className='text-center my-10'>No Data</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
